<div class="workspace">
  <div class="infl-container">
    <div class="basic-info-container">
      <div class="row basic-info">
        <div class="col-sm-12 col-md-12 influencer-basic-info-container">
          <div class="influencer-basic-info">
            <achoo-placeholder [facebookPlaceholder]="true"
                               [normalPlaceholder]="false"
                               [placeholderId]="'influencerBasicInformation'">
              <app-influencer-basic-information
                [influencer]="influencerDetailsData"
                [enableForMediaPlatform]="false"
                [supportIgStoryLoader]="true"
                [showCountryFlagIcon]="true">
              </app-influencer-basic-information>
            </achoo-placeholder>
          </div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="main-infl-content">
      <div class="tab-container">
        <div class="tab-title">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item overview-tab">
              <a class="nav-link" [ngClass]="{'active': isActiveOverviewTab}" data-toggle="tab" (click)="showOverview()" role="tab">{{ 'INFLUENCER.OVERVIEW' | translate }}</a>
            </li>
            <li class="nav-item insight-tab">
              <a class="nav-link" [ngClass]="{'active': isActiveInsightTab}" data-toggle="tab" (click)="showInsight()" role="tab">{{ 'INFLUENCER.ACTIVITY' | translate }}</a>
            </li>
            <li class="nav-item demographic-tab">
              <a class="nav-link" [ngClass]="{'active': isActiveDemographicTab}" data-toggle="tab" (click)="showDemographics()" role="tab">{{ 'INFLUENCER.DEMOGRAPHICS' | translate }}</a>
            </li>
          </ul>
        </div>


        <div class="tab-content" >
          <influencer-overview-tab *ngIf="isActiveOverviewTab"
                                   [influencerId]="currentInfluencerId"
                                   (changeActiveChannel)="onChangeActiveChannel($event)">
          </influencer-overview-tab>
          <div *ngIf="isActiveInsightTab" class="insight-tab-mobile">
            <influencer-insight [influencerId]="currentInfluencerId"
                                [enableInfluencerPlatform]="true"
                                (changeActiveChannel)="onChangeActiveChannel($event)">
            </influencer-insight>
            <div class="d-block d-sm-none demographic-page-mobile">
              <div class="demographics-page-title">{{ 'INFLUENCER.DEMOGRAPHICS' | translate }}</div>
              <demographic-page #InfluencerDemographic
                                [demoInfluencerId]="currentInfluencerId"
                                [isMobile]="true">
              </demographic-page>
            </div>
          </div>
          <demographic-page *ngIf="isActiveDemographicTab"
                            [demoInfluencerId]="currentInfluencerId"
                            [selectedChannel]="demographicChannelParam"
                            (changeDemographicSourceEvent)="changeDemographicSource($event)">
          </demographic-page>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottombar">
  <div class="row full-height">
    <div class="col-md-12 buttons-manage align-items-end">
      <div class="buttons d-flex flex-auto justify-content-end">
        <button class="button blue"
                (click)="downloadPDF()">
          {{'common.btn.export_report' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closePopup()"
             (cancelCallback)="closePopup()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-details.component.html